module.exports = __webpack_public_path__ + "static/media/unevenhip_normal.eef38c86.png";